import React, {createContext, useContext} from 'react';

import type {ArgumentsType} from '@netx/core/typings';
import {useVirtualizedListArrowTabTrap} from '../../hooks';

export type FocusTrapItemContextType = ReturnType<
	typeof useVirtualizedListArrowTabTrap
>;

const StoreContext = createContext<FocusTrapItemContextType | undefined>(
	undefined,
);

export const useVirtualizedListArrowTabTrapProvider = () => {
	const context = useContext(StoreContext);
	if (context === undefined) {
		throw new Error(
			'`useVirtualizedListArrowTabTrapProvider` must be used within a `VirtualizedListArrowTabTrapProvider`',
		);
	}
	return context;
};

export type VirtualizedListArrowTabTrapProviderProps = React.PropsWithChildren<
	ArgumentsType<typeof useVirtualizedListArrowTabTrap>[0]
>;

export const VirtualizedListArrowTabTrapProvider = ({
	children,
	...props
}: VirtualizedListArrowTabTrapProviderProps) => {
	const virtualizedListArrowTabTrap = useVirtualizedListArrowTabTrap(props);

	return (
		<StoreContext.Provider value={virtualizedListArrowTabTrap}>
			{children}
		</StoreContext.Provider>
	);
};

export default VirtualizedListArrowTabTrapProvider;
